import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import Sidebar from "../components/Common/Sidebar";
import Navbar from "../components/Common/NavBar";
const Layout = () => {
  const [isSideBarClosed, setIsSideBarClosed] = useState();
  const location = useLocation();
  const activePath = location.pathname;
  return (
    <section className="min-h-screen dark:bg-accent-900 bg-[#fbfbfc] duration-300">
      <Navbar />
      <Sidebar setIsSideBarClosed={setIsSideBarClosed} active={activePath} />
      <section className={`back-office-pagee ${isSideBarClosed ? "md:left-[77px] md:w-[calc(100%-77px)]" : "md:left-[200px] md:w-[calc(100%-200px)]"} pt-[65px] duration-300 min-h-scree relative top-0 right-0 w-full`}>
        <div className="py-30px md:30px px-20px pb-20">
          <Outlet />
        </div>
      </section>
    </section>
  );
};

export default Layout;
